export const FEATURE_FLAGS = {
  // when false, all onboarding‐related routes & links are hidden/blocked
  ONBOARDING: true,
  // when false, all settings‐related routes & links are hidden/blocked
  SETTINGS: true,
  BUSINESS_STATUS: false,
  PORTFOLIO_FILTERS: false,
  BUSINESS_FILTERS: false,
};
